'use strict';
moduleConfig.registerModule('uteAddToCalendar', ['ute.ui', 'ute.datalayer.common']);
